import React from "react";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import { unsplashBackground } from "../../utils/constants";

function Signup() {
  const backgroundImage = unsplashBackground;

  return (
    <div
      className="h-screen w-screen poppins-regular     "
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="bg-white bg-opacity-50 h-full w-full flex flex-col items-center justify-center">
        <div>
          <SignupForm />
        </div>
      </div>
    </div>
  );
}

export default Signup;
